/** How long a run took, in plain units: "12 s", "3 min 5 s", "1 h 4 min". '' when it has not finished. */
const formatRunDuration = (startedAt, finishedAt) => {
  const start = Date.parse(startedAt || '');
  const end = Date.parse(finishedAt || '');

  if (!Number.isFinite(start) || !Number.isFinite(end) || end < start) {
    return '';
  }

  const seconds = Math.round((end - start) / 1000);

  if (seconds < 60) {
    return `${seconds} s`;
  }

  const minutes = Math.floor(seconds / 60);

  if (minutes < 60) {
    return seconds % 60 ? `${minutes} min ${seconds % 60} s` : `${minutes} min`;
  }

  return minutes % 60 ? `${Math.floor(minutes / 60)} h ${minutes % 60} min` : `${Math.floor(minutes / 60)} h`;
};

export default formatRunDuration;
